import {
  APIGWAllowedListAction,
  APIGWAllowedListState,
  apiGWAllowedListCache,
} from 'lib/store/apiGateway/actions';
import {
  API_GATEWAY_ALLOWED_LIST_FAILURE,
  API_GATEWAY_ALLOWED_LIST_SUCCESS,
} from './actionTypes';

export const initialState: APIGWAllowedListState = {
  useApiGateway: false,
  apiGWAllowedList: [],
};

export default function apiGWAllowedListReducer(
  state: APIGWAllowedListState = initialState,
  action: APIGWAllowedListAction,
) {
  switch (action.type) {
    case API_GATEWAY_ALLOWED_LIST_SUCCESS:
      // resetting cache to empty on api gateway allowed list call
      apiGWAllowedListCache.clear();
      return {
        ...state,
        useApiGateway: true,
        apiGWAllowedList: action.payload.apiGWAllowedList,
      };

    case API_GATEWAY_ALLOWED_LIST_FAILURE:
      apiGWAllowedListCache.clear();
      return { ...state, useApiGateway: false };

    default:
      return state;
  }
}
